import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type HeaderItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.AanvragenHeader, {
  isVisible: () => true,
  create: (): HeaderItem => ({
    itemtype: 'header',
    menuItem: MenuItems.AanvragenHeader,
    title: 'Aanvragen',
  }),
});
